import { ISrcSet } from "@kursk/components/ui/Picture/Picture";
import { ICarouselOptions } from "@kursk/components/ui/Carousel/Carousel";

import styles from "../HeaderBlockImages.module.scss";

export const SRC_SET: ISrcSet[] = [
  {
    media: "(min-width: 1200px)",
    width: 600,
    height: 400,
  },
  {
    media: "(min-width: 768px) and (max-width: 1199px)",
    width: 600,
    height: 400,
  },
  {
    media: "(max-width: 767px)",
    width: 600,
    height: 400,
  },
];

export const OPTIONS: ICarouselOptions = {
  infinite: true,
  autoPlay: true,
  autoPlaySpeed: 5000,
  pauseOnHover: true,
  containerClass: styles.react_multi_carousel_list,
};
